import type { SVGProps } from 'react'

const SvgArrowDropUp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 -960 960 960' {...props}>
    <path d='M328-400q-9 0-14.5-6t-5.5-14q0-2 6-14l145-145q5-5 10-7t11-2q6 0 11 2t10 7l145 145q3 3 4.5 6.5t1.5 7.5q0 8-5.5 14t-14.5 6z' />
  </svg>
)

export default SvgArrowDropUp
